import { useState } from 'react';
import { useNavigate } from '@tanstack/react-router';

import { SignInForm } from '../components/SignInForm';
import { LoginEditorial } from '../layouts/AuthEditorial';
import { AuthSplitLayout } from '../layouts/AuthSplitLayout';
import { ProfessionalSignupForm } from '../components/ProfessionalSignupForm';

// There used to be a chooser here: a personal workspace for a family's own
// records, or a clinic. Personal records moved to biolockr, so MohairNotes is
// clinical only and "Create an account" now means one thing. With a single
// destination the intermediate step was a question with one answer, so it went
// with it.
type Step = { kind: 'signin' } | { kind: 'signup' };

const DEFAULT_NEXT_ROUTE = '/patients' as const;

const HEADINGS: Record<Step['kind'], string> = {
  signin: 'Log in',
  signup: 'Register your practice',
};

export function LoginPage() {
  const navigate = useNavigate();
  const [step, setStep] = useState<Step>({ kind: 'signin' });

  const goSuccess = () => navigate({ to: DEFAULT_NEXT_ROUTE });

  return (
    <AuthSplitLayout
      left={<LoginEditorial />}
      right={
        <>
          <h2 className="mb-6 font-display text-[26px] tracking-[-0.02em]">{HEADINGS[step.kind]}</h2>

          {step.kind === 'signin' && (
            <SignInForm onSuccess={goSuccess} onCreateAccount={() => setStep({ kind: 'signup' })} />
          )}
          {step.kind === 'signup' && (
            <ProfessionalSignupForm
              onSuccess={goSuccess}
              onBack={() => setStep({ kind: 'signin' })}
              onSignIn={() => setStep({ kind: 'signin' })}
            />
          )}
        </>
      }
    />
  );
}
